module.exports = __webpack_public_path__ + "img/14.cb36884b.jpg";